import {createSelector} from 'reselect';
import getBasketContainsSubscriptionBySku from './getBasketContainsSubscriptionBySku';
import getBasketItems from './orderSummaryBasketItemsSelector';

export default createSelector(
  [getBasketItems, getBasketContainsSubscriptionBySku],
  (basketItems, basketContainsSubscriptionBySku) => basketContainsSubscriptionBySku || !!basketItems
    ?.some(basketItem => basketItem.isSubscription),
);
